"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractServiceFacade = _interopRequireDefault(require("../AbstractServiceFacade"));

var _ServiceFacadeException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ServiceFacadeException"));

var _ServiceFactory = _interopRequireDefault(require("../ServiceFactory"));

var _LocalizationServiceFacade = _interopRequireDefault(require("./LocalizationServiceFacade"));

var _LocalizationUtility = _interopRequireDefault(require("../util/LocalizationUtility"));

var _ikeaSharedUtils = require("@ikea-aoa/ikea-shared-utils");

var _EcommerceCartDataSourceConstant = _interopRequireDefault(require("../constant/EcommerceCartDataSourceConstant"));

var _EcommerceShoppingListDataSourceConstant = _interopRequireDefault(require("../constant/EcommerceShoppingListDataSourceConstant"));

var _ApiPlatformConstant = _interopRequireDefault(require("../constant/ApiPlatformConstant"));

var _ServiceSettings = _interopRequireDefault(require("../ServiceSettings"));

var _services = require("@ikea-aoa/services");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SHOPPING_LIST_NAME_TRANSLATION_KEY = 'PLANNER_SHOPPING_LIST_NAME';
/**
 * This class is used as a simple interface for shopping services.
 */

var ShoppingServiceFacade = /*#__PURE__*/function (_AbstractServiceFacad) {
  _inherits(ShoppingServiceFacade, _AbstractServiceFacad);

  var _super = _createSuper(ShoppingServiceFacade);

  function ShoppingServiceFacade() {
    _classCallCheck(this, ShoppingServiceFacade);

    return _super.apply(this, arguments);
  }

  _createClass(ShoppingServiceFacade, null, [{
    key: "addItemsToBag",

    /**
     * Adds items to shopping bag.
     *
     * @throws ServiceFacadeException
     * @example ShoppingServiceFacade.addItemsToBag([ { type: 'ART', id: '123456', qty: 2 }, { type: 'ART', id: '654321', qty: 1 } ]).then(() => {
     * // Articles has been successfully added
     * }).catch(error => {
     * // Handle error
     * });
     * @param {object[]} items Array of retail item objects.
     * @param {string} bagType Nag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} [roigVpcCode] VPC code for ROIG. Will only be used if API platform is set to ROIG. Default value is "null".
     * @returns {Promise} Promise object.
     */
    value: function addItemsToBag(items, bagType) {
      var _this = this;

      var roigVpcCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return _LocalizationServiceFacade.default.getData().then(function (data) {
        var eCommerceCartDataSource = _LocalizationUtility.default.getAppSettingValue(data, 'eCommerceCartDataSource') || 'default';
        var eCommerceShoppingListDataSource = _LocalizationUtility.default.getAppSettingValue(data, 'eCommerceShoppingListDataSource') || 'default';
        var apiPlatform = data.localization.apiPlatform;
        var bagName = _ServiceSettings.default.irwBagName || data.translations[SHOPPING_LIST_NAME_TRANSLATION_KEY] || bagType;

        if (bagType === 'onlineshoppinglist') {
          switch (eCommerceShoppingListDataSource) {
            case _EcommerceShoppingListDataSourceConstant.default.shoppingListApi:
              return _this._addItemsToBagOneWeb({
                apiLocalePath: data.apiLocalePath,
                endpoints: data.endpoints,
                clientId: data.localization.ingkaShoppingListClientId,
                clientSecret: data.localization.ingkaShoppingListClientSecret,
                bagType: bagType,
                bagName: bagName,
                items: items
              });

            case _EcommerceShoppingListDataSourceConstant.default.chinaShoppingListApi:
              return _this._addItemsToBagChina({
                localizedInformation: data,
                bagType: bagType,
                items: items
              });

            case _EcommerceShoppingListDataSourceConstant.default.iows:
              return _this._addItemsToBagIows({
                apiLocalePath: data.apiLocalePath,
                items: items,
                bagType: bagType,
                bagName: bagName
              });

            case _EcommerceShoppingListDataSourceConstant.default.mvecom:
              return _this._addItemsToMvEcom({
                localizedInformation: data,
                items: items,
                bagType: bagType,
                bagName: bagName
              });

            case _EcommerceShoppingListDataSourceConstant.default.default:
              switch (eCommerceCartDataSource) {
                case _EcommerceCartDataSourceConstant.default.iows:
                case _EcommerceCartDataSourceConstant.default.cartApi:
                  return _this._addItemsToBagIows({
                    apiLocalePath: data.apiLocalePath,
                    items: items,
                    bagType: bagType,
                    bagName: bagName
                  });

                case _EcommerceCartDataSourceConstant.default.default:
                  switch (apiPlatform) {
                    case _ApiPlatformConstant.default.irw:
                      return _this._addItemsToBagIows({
                        apiLocalePath: data.apiLocalePath,
                        items: items,
                        bagType: bagType,
                        bagName: bagName
                      });

                    default:
                      throw new _ServiceFacadeException.default('Failed to add items to shopping list. API platform "' + apiPlatform + '" is not supported.', _this.constructor.serviceName);
                  }

                default:
                  throw new _ServiceFacadeException.default('Failed to add items to shopping list. Cart data source "' + eCommerceCartDataSource + '" is not supported.', _this.constructor.serviceName);
              }

            default:
              throw new _ServiceFacadeException.default('Failed to add items to shopping list. Shopping list data source "' + eCommerceShoppingListDataSource + '" is not supported.', _this.constructor.serviceName);
          }
        }

        switch (eCommerceCartDataSource) {
          case _EcommerceCartDataSourceConstant.default.cartApi:
            return _this._addItemsToBagOneWeb({
              apiLocalePath: data.apiLocalePath,
              endpoints: data.endpoints,
              clientId: data.localization.ingkaShoppingCartClientId,
              clientSecret: data.localization.ingkaShoppingCartClientSecret,
              bagType: bagType,
              bagName: bagName,
              items: items
            });

          case _EcommerceCartDataSourceConstant.default.chinaCartApi:
            return _this._addItemsToBagChina({
              localizedInformation: data,
              bagType: bagType,
              items: items
            });

          case _EcommerceCartDataSourceConstant.default.iows:
            return _this._addItemsToBagIows({
              apiLocalePath: data.apiLocalePath,
              items: items,
              bagType: bagType,
              bagName: bagName
            });

          case _EcommerceCartDataSourceConstant.default.mvecom:
            return _this._addItemsToMvEcom({
              localizedInformation: data,
              items: items,
              bagType: bagType,
              bagName: bagName
            });

          case _EcommerceCartDataSourceConstant.default.nifApi:
            return _this._addItemsToBagNif({
              items: items,
              vpcCode: roigVpcCode,
              endpoints: data.endpoints,
              retailUnit: data.localization.countryCode,
              languageCode: data.localization.languageCode
            });

          case _EcommerceCartDataSourceConstant.default.roig:
            return _this._addItemsToBagRoigIframe({
              items: items,
              vpcCode: roigVpcCode
            });

          case _EcommerceCartDataSourceConstant.default.default:
            switch (apiPlatform) {
              case _ApiPlatformConstant.default.irw:
                return _this._addItemsToBagIows({
                  apiLocalePath: data.apiLocalePath,
                  items: items,
                  bagType: bagType,
                  bagName: bagName
                });

              case _ApiPlatformConstant.default.roig:
                return _this._addItemsToBagRoigIframe({
                  items: items,
                  vpcCode: roigVpcCode
                });

              default:
                throw new _ServiceFacadeException.default('Failed to add items to shopping cart. API platform "' + apiPlatform + '" is not supported.', _this.constructor.serviceName);
            }

          default:
            throw new _ServiceFacadeException.default('Failed to add items to shopping cart. Cart data source "' + eCommerceCartDataSource + '" is not supported.', _this.constructor.serviceName);
        }
      });
    }
    /**
     * Returns the cart count.
     *
     * @throws ServiceFacadeException
     * @param {string} bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @returns {Promise} Promise object.
     */

  }, {
    key: "getCartCount",
    value: function getCartCount(bagType) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        return _this2._latch.aquire().then(function (release) {
          _LocalizationServiceFacade.default.getData().then(function (data) {
            var eCommerceCartDataSource = _LocalizationUtility.default.getAppSettingValue(data, 'eCommerceCartDataSource') || 'default';
            var eCommerceShoppingListDataSource = _LocalizationUtility.default.getAppSettingValue(data, 'eCommerceShoppingListDataSource') || 'default';
            var apiPlatform = data.localization.apiPlatform;
            var apiLocalePath = data.apiLocalePath;
            var bagName = _ServiceSettings.default.irwBagName || data.translations[SHOPPING_LIST_NAME_TRANSLATION_KEY] || bagType;

            if (bagType === 'onlineshoppinglist') {
              switch (eCommerceShoppingListDataSource) {
                case _EcommerceShoppingListDataSourceConstant.default.shoppingListApi:
                  _this2._getCartCountOneweb({
                    apiLocalePath: apiLocalePath,
                    endpoints: data.endpoints,
                    clientId: data.localization.ingkaShoppingListClientId,
                    clientSecret: data.localization.ingkaShoppingListClientSecret,
                    bagType: bagType,
                    bagName: bagName
                  }).then(function (cartCount) {
                    release();
                    resolve(cartCount);
                  }).catch(function (error) {
                    release();
                    reject(error);
                  });

                  break;

                case _EcommerceShoppingListDataSourceConstant.default.chinaShoppingListApi:
                  _this2._getCartCountChina({
                    localizedInformation: data,
                    bagType: bagType
                  }).then(function (cartCount) {
                    release();
                    resolve(cartCount);
                  }).catch(function (error) {
                    release();
                    reject(error);
                  });

                  break;

                case _EcommerceShoppingListDataSourceConstant.default.iows:
                  _this2._getCartCountIows(apiLocalePath, bagType, bagName).then(function (cartCount) {
                    release();
                    resolve(cartCount);
                  }).catch(function (error) {
                    release();
                    reject(error);
                  });

                  break;

                case _EcommerceShoppingListDataSourceConstant.default.mvecom:
                  _this2._getCountMvEcom({
                    localizedInformation: data,
                    bagType: bagType,
                    bagName: bagName
                  }).then(function (cartCount) {
                    release();
                    resolve(cartCount);
                  }).catch(function (error) {
                    release();
                    reject(error);
                  });

                  break;

                case _EcommerceShoppingListDataSourceConstant.default.default:
                  switch (eCommerceCartDataSource) {
                    case _EcommerceCartDataSourceConstant.default.iows:
                    case _EcommerceCartDataSourceConstant.default.cartApi:
                      _this2._getCartCountIows(apiLocalePath, bagType, bagName).then(function (cartCount) {
                        release();
                        resolve(cartCount);
                      }).catch(function (error) {
                        release();
                        reject(error);
                      });

                      break;

                    case _EcommerceCartDataSourceConstant.default.default:
                      switch (apiPlatform) {
                        case _ApiPlatformConstant.default.irw:
                          _this2._getCartCountIows(apiLocalePath, bagType, bagName).then(function (cartCount) {
                            release();
                            resolve(cartCount);
                          }).catch(function (error) {
                            release();
                            reject(error);
                          });

                          break;

                        default:
                          throw new _ServiceFacadeException.default('Failed to get cart count. API platform "' + apiPlatform + '" is not supported.', _this2.constructor.serviceName);
                      }

                      break;

                    default:
                      throw new _ServiceFacadeException.default('Failed to get cart count. Cart data source "' + eCommerceCartDataSource + '" is not supported.', _this2.constructor.serviceName);
                  }

                  break;

                default:
                  throw new _ServiceFacadeException.default('Failed to get cart count. Shopping list data source "' + eCommerceShoppingListDataSource + '" is not supported.', _this2.constructor.serviceName);
              }
            } else {
              switch (eCommerceCartDataSource) {
                case _EcommerceCartDataSourceConstant.default.cartApi:
                  _this2._getCartCountOneweb({
                    apiLocalePath: apiLocalePath,
                    endpoints: data.endpoints,
                    clientId: data.localization.ingkaShoppingCartClientId,
                    clientSecret: data.localization.ingkaShoppingCartClientSecret,
                    bagType: bagType,
                    bagName: bagName
                  }).then(function (cartCount) {
                    release();
                    resolve(cartCount);
                  }).catch(function (error) {
                    release();
                    reject(error);
                  });

                  break;

                case _EcommerceCartDataSourceConstant.default.chinaCartApi:
                  _this2._getCartCountChina({
                    localizedInformation: data,
                    bagType: bagType
                  }).then(function (cartCount) {
                    release();
                    resolve(cartCount);
                  }).catch(function (error) {
                    release();
                    reject(error);
                  });

                  break;

                case _EcommerceCartDataSourceConstant.default.iows:
                  _this2._getCartCountIows(apiLocalePath, bagType, bagName).then(function (cartCount) {
                    release();
                    resolve(cartCount);
                  }).catch(function (error) {
                    release();
                    reject(error);
                  });

                  break;

                case _EcommerceCartDataSourceConstant.default.mvecom:
                  _this2._getCountMvEcom({
                    localizedInformation: data,
                    bagType: bagType,
                    bagName: bagName
                  }).then(function (cartCount) {
                    release();
                    resolve(cartCount);
                  }).catch(function (error) {
                    release();
                    reject(error);
                  });

                  break;

                case _EcommerceCartDataSourceConstant.default.nifApi:
                  _this2._getCartCountNif({
                    apiLocalePath: apiLocalePath,
                    endpoints: data.endpoints
                  }).then(function (cartCount) {
                    release();
                    resolve(cartCount);
                  }).catch(function (error) {
                    release();
                    reject(error);
                  });

                  break;

                case _EcommerceCartDataSourceConstant.default.default:
                  switch (apiPlatform) {
                    case _ApiPlatformConstant.default.irw:
                      _this2._getCartCountIows(apiLocalePath, bagType, bagName).then(function (cartCount) {
                        release();
                        resolve(cartCount);
                      }).catch(function (error) {
                        release();
                        reject(error);
                      });

                      break;

                    default:
                      throw new _ServiceFacadeException.default('Failed to get cart count. API platform "' + apiPlatform + '" is not supported.', _this2.constructor.serviceName);
                  }

                  break;

                default:
                  throw new _ServiceFacadeException.default('Failed to get cart count. Cart data source "' + eCommerceCartDataSource + '" is not supported.', _this2.constructor.serviceName);
              }
            }
          }).catch(function (error) {
            release();
            reject(error);
          });
        });
      });
    }
    /**
     * Adds items to shopping bag in One Web.
     *
     * @throws ServiceException
     * @param {object} config Configuration.
     * @param {string} config.apiLocalePath API locale path. Example: "gb/en".
     * @param {object[]} config.endpoints API endpoints.
     * @param {string} config.clientId Client credential for api.
     * @param {string} config.clientSecret Client credential for api.
     * @param {object[]} config.items Array of retail item objects.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_addItemsToBagOneWeb",
    value: function _addItemsToBagOneWeb(config) {
      return _ServiceFactory.default.getService('onewebauth').getToken(config).then(function (_ref) {
        var token = _ref.token;

        if (config.bagType === 'onlineshoppinglist') {
          return _ServiceFactory.default.getService('onewebshoppinglist').addToShoppingList(Object.assign({}, config, {
            token: token
          }));
        }

        return _ServiceFactory.default.getService('onewebcart').addToCart(Object.assign({}, config, {
          token: token
        }));
      });
    }
    /**
     * Adds items to shopping bag in China.
     *
     * @throws ServiceException
     * @param {object} config Configuration.
     * @param {object} config.items Oversatta data.
     * @param {object} config.localizedInformation Oversatta data.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_addItemsToBagChina",
    value: function _addItemsToBagChina(config) {
      var usingProxy = location.host.startsWith('ikea-') || !location.host.startsWith('ikea') && !location.host.startsWith('www.ikea') && !_ServiceSettings.default.forceProductionChinaApi;
      var cartService = new _services.ChinaCartService({
        endpoint: config.localizedInformation.endpoints.chinaCartService
      });
      var shoppingListService = new _services.ChinaShoppingListService({
        endpoint: config.localizedInformation.endpoints.chinaShoppingListService
      });

      var _config$localizedInfo = config.localizedInformation.localization.locale.split('_'),
          _config$localizedInfo2 = _slicedToArray(_config$localizedInfo, 2),
          language = _config$localizedInfo2[0],
          country = _config$localizedInfo2[1];

      var authService = new _services.ChinaAuthenticationService({
        refreshTokenEndpoint: config.localizedInformation.endpoints.chinaAuthenticationRefreshToken,
        loginPageEndpoint: usingProxy ? '/china-login-page/' : config.localizedInformation.endpoints.chinaAuthenticationLoginPage.replace('{country}', country.toLowerCase()).replace('{language}', language)
      });

      if (config.bagType === 'onlineshoppinglist') {
        return authService.getToken().then(function (token) {
          return shoppingListService.addToList({
            items: config.items.map(function (item) {
              return {
                type: item.type,
                id: item.id,
                quantity: item.qty
              };
            }),
            token: token
          });
        });
      }

      return authService.getToken().then(function (token) {
        return cartService.addToCart({
          items: config.items.map(function (item) {
            return {
              type: item.type,
              id: item.id,
              quantity: item.qty
            };
          }),
          token: token
        });
      });
    }
    /**
     * Adds items to shopping bag in IOWS/IRW.
     *
     * @throws ServiceException
     * @param {object} config Configuration.
     * @param {string} config.apiLocalePath API locale path. Example: "gb/en".
     * @param {object[]} config.endpoints API endpoints.
     * @param {object[]} config.items Array of retail item objects.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_addItemsToBagIows",
    value: function _addItemsToBagIows(config) {
      return _ServiceFactory.default.getService('irwauth').getUser(config.apiLocalePath).then(function (_ref2) {
        var userId = _ref2.userId;
        return _ServiceFactory.default.getService('shoppingbag').addToCart(Object.assign({}, config, {
          userId: userId
        })).then(function (response) {
          return _ServiceFactory.default.getService('irwplatform').setCartCount(response.CartCount).then(function () {
            return response;
          });
        });
      });
    }
    /**
     * Adds items to shopping bag in MvEcom.
     *
     * @throws ServiceException
     * @param {object} config Configuration.
     * @param {object} config.localizedInformation Oversatta data.
     * @param {object[]} config.items Array of retail item objects.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_addItemsToMvEcom",
    value: function _addItemsToMvEcom(config) {
      return _ServiceFactory.default.getService('irwauth').getUser(config.localizedInformation.apiLocalePath).then(function (_ref3) {
        var userId = _ref3.userId;

        if (config.bagType === 'onlineshoppinglist') {
          return _ServiceFactory.default.getService('mvecom').addToList(Object.assign({}, config, {
            userId: userId
          }));
        }

        return _ServiceFactory.default.getService('mvecom').addToCart(Object.assign({}, config, {
          userId: userId
        })).then(function (response) {
          return _ServiceFactory.default.getService('irwplatform').setCartCount(response.CartCount).then(function () {
            return response;
          });
        });
      });
    }
    /**
     * Adds items to shopping bag in NIF.
     *
     * @throws ServiceException
     * @param {object} config Configuration.
     * @param {object[]} config.items Array of retail item objects.
     * @param {object[]} config.vpcCode VPC code.
     * @param {object[]} config.endpoints Endpoints.
     * @param {object[]} config.retailUnit Retail unit, ie country code.
     * @param {object[]} config.languageCode Language code.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_addItemsToBagNif",
    value: function _addItemsToBagNif(config) {
      return new Promise(function (resolve, reject) {
        // if eCommerce is enabled, do iframe post AND API call to get the same begavior as INKGA
        var cartService = _ServiceFactory.default.getService('nifcart');

        return _ServiceFactory.default.getService('nifauth').getUser(config).then(function () {
          return cartService.getCarts(config);
        }).then(function (carts) {
          if (carts && carts instanceof Array && carts.length > 0) {
            return carts[0];
          } else {
            return cartService.createCart(config);
          }
        }).then(function (cart) {
          return cartService.addCartItems(config, cart.id);
        }).then(function (response) {
          return _ServiceFactory.default.getService('roigplatform').setCartCount(response.CartCount);
        }).then(resolve.bind(null, {
          ErrorList: []
        })).catch(reject);
      });
    }
    /**
     * Adds items to shopping bag in ROIG.
     *
     * @throws ServiceException
     * @param {object} config Configuration.
     * @param {object[]} config.items Array of retail item objects.
     * @param {object[]} config.vpcCode VPC code.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_addItemsToBagRoigIframe",
    value: function _addItemsToBagRoigIframe(config) {
      return new Promise(function (resolve, reject) {
        return _ServiceFactory.default.getService('roigplatform').addToShoppingBag(config.items, config.vpcCode).then(resolve.bind(null, {
          ErrorList: []
        })).catch(reject);
      });
    }
    /**
     * Returns cart count for One Web.
     *
     * @param {object} config Configuration.
     * @param {object} config.endpoints API endpoints.
     * @param {string} config.clientId Client credential for api.
     * @param {string} config.clientSecret Client credential for api.
     * @param {string} config.apiLocalePath API locale path. Example: "gb/en".
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_getCartCountOneweb",
    value: function _getCartCountOneweb(config) {
      return _ServiceFactory.default.getService('onewebauth').getToken(config).then(function (_ref4) {
        var token = _ref4.token;

        if (config.bagType === 'onlineshoppinglist') {
          return _ServiceFactory.default.getService('onewebshoppinglist').getListCount(Object.assign({}, config, {
            token: token
          }));
        }

        return _ServiceFactory.default.getService('onewebcart').getCartCount(Object.assign({}, config, {
          token: token
        }));
      });
    }
    /**
     * Returns cart count for China.
     *
     * @throws ServiceException
     * @param {object} config Configuration.
     * @param {object} config.localizedInformation Oversatta data.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_getCartCountChina",
    value: function _getCartCountChina(config) {
      var cartService = new _services.ChinaCartService({
        endpoint: config.localizedInformation.endpoints.chinaCartService
      });
      var shoppingListService = new _services.ChinaShoppingListService({
        endpoint: config.localizedInformation.endpoints.chinaShoppingListService
      });

      var _config$localizedInfo3 = config.localizedInformation.localization.locale.split('_'),
          _config$localizedInfo4 = _slicedToArray(_config$localizedInfo3, 2),
          language = _config$localizedInfo4[0],
          country = _config$localizedInfo4[1];

      var authService = new _services.ChinaAuthenticationService({
        refreshTokenEndpoint: config.localizedInformation.endpoints.chinaAuthenticationRefreshToken,
        loginPageEndpoint: config.localizedInformation.endpoints.chinaAuthenticationLoginPage.replace('{country}', country.toLowerCase()).replace('{language}', language)
      });

      if (config.bagType === 'onlineshoppinglist') {
        return authService.getToken().then(function (token) {
          return shoppingListService.getListCount({
            token: token
          });
        });
      }

      return authService.getToken().then(function (token) {
        return cartService.getCartCount({
          token: token
        });
      });
    }
    /**
     * Returns cart count from IOWS/IRW.
     *
     * @param {string} apiLocalePath API locale path. Example: "gb/en".
     * @param {string} bagType IRW bag type.
     * @param {string} bagName IRW bag name.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_getCartCountIows",
    value: function _getCartCountIows(apiLocalePath, bagType, bagName) {
      return _ServiceFactory.default.getService('irwauth').getUser(apiLocalePath).then(function (_ref5) {
        var userId = _ref5.userId;
        return _ServiceFactory.default.getService('shoppingbag').getCartCount({
          userId: userId,
          apiLocalePath: apiLocalePath,
          bagType: bagType,
          bagName: bagName
        });
      });
    }
    /**
     * Returns cart count for MvEcom.
     *
     * @throws ServiceException
     * @param {object} config Configuration.
     * @param {object} config.localizedInformation Oversatta data.
     * @param {string} config.bagType IRW bag type. Valid values: "onlineshoppingcart", "onlineshoppinglist".
     * @param {string} config.bagName IRW bag name.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_getCountMvEcom",
    value: function _getCountMvEcom(config) {
      return _ServiceFactory.default.getService('irwauth').getUser(config.localizedInformation.apiLocalePath).then(function (_ref6) {
        var userId = _ref6.userId;

        if (config.bagType === 'onlineshoppinglist') {
          return _ServiceFactory.default.getService('mvecom').getListCount(Object.assign({}, config, {
            userId: userId
          }));
        }

        return _ServiceFactory.default.getService('mvecom').getCartCount(Object.assign({}, config, {
          userId: userId
        }));
      });
    }
    /**
     * Returns cart count from NIF/ROIG.
     *
     * @param {object} config Configuration.
     * @param {object} config.endpoints API endpoints.
     * @param {object[]} config.retailUnit Retail unit, ie country code.
     * @param {object[]} config.languageCode Language code.
     * @returns {Promise} Promise object.
     */

  }, {
    key: "_getCartCountNif",
    value: function _getCartCountNif(config) {
      var cartService = _ServiceFactory.default.getService('nifcart');

      return _ServiceFactory.default.getService('nifauth').getUser(config).then(function () {
        return cartService.getCarts(config);
      }).then(function (cartArray) {
        if (cartArray && cartArray.length > 0) {
          return cartArray[0];
        } else {
          return cartService.createCart(config);
        }
      }).then(function (cart) {
        return cartService.getCartCount(config, cart.id);
      });
    }
    /**
     * Returns data source.
     *
     * @param {object} localization Localization.
     * @returns {string} Data source.
     */

  }, {
    key: "_getEcommerceCartDataSource",
    value: function _getEcommerceCartDataSource(localization) {
      if (localization.apiPlatform === _ApiPlatformConstant.default.irw || localization.apiPlatform === _ApiPlatformConstant.default.roig) {
        var eCommerceCartDataSource = _LocalizationUtility.default.getAppSettingValue({
          localization: localization
        }, 'eCommerceCartDataSource') || 'default';

        if (eCommerceCartDataSource && eCommerceCartDataSource !== 'default') {
          return eCommerceCartDataSource;
        }
      }

      switch (localization.apiPlatform) {
        case _ApiPlatformConstant.default.irw:
          return _EcommerceCartDataSourceConstant.default.iows;

        case _ApiPlatformConstant.default.roig:
          return _EcommerceCartDataSourceConstant.default.roig;

        case _ApiPlatformConstant.default.mvecom:
          return _EcommerceCartDataSourceConstant.default.mvecom;
      }

      return null;
    }
    /**
     * Returns the service name.
     *
     * @override
     * @returns {string} Service name.
     */

  }, {
    key: "serviceName",
    get: function get() {
      return 'ShoppingServiceFacade';
    }
  }]);

  return ShoppingServiceFacade;
}(_AbstractServiceFacade.default);

exports.default = ShoppingServiceFacade;

_defineProperty(ShoppingServiceFacade, "_latch", new _ikeaSharedUtils.Latch());